import { Observable } from 'rxjs';
import {
  CompanyCommissionsMatrix,
  CommissionsReadDto,
  MerchantCommissionsMarkup,
  UnitCommissionsMarkup,
} from '@app/data/dtos/tpv/commissions.dto';

/**
 * Port para el CRUD unificado de comisiones en 3 niveles (§1).
 * Permiso backend: pricing es manage-level (admin / gestor TPV).
 *
 * - Empresa: `idCompany` = PK ENTERO de la org (la capa resuelve el UUID TPV).
 * - Unidad: `idCompany` + `idUnit` (UUID).
 * - Comercio: `idMerchant` (UUID).
 */
export abstract class CommissionsRepository {
  // ── Empresa: matriz completa (CRUD real, espejo local en Polipay) ──────────
  abstract getCompanyCommissions(idCompany: string): Observable<CommissionsReadDto | null>;
  abstract createCompanyCommissions(idCompany: string, body: CompanyCommissionsMatrix): Observable<void>;
  abstract updateCompanyCommissions(idCompany: string, body: Partial<CompanyCommissionsMatrix>): Observable<void>;
  abstract deleteCompanyCommissions(idCompany: string): Observable<void>;

  // ── Unidad: markup (lee live del micro) ────────────────────────────────────
  abstract getUnitCommissions(idCompany: string, idUnit: string): Observable<CommissionsReadDto | null>;
  abstract updateUnitCommissions(idCompany: string, idUnit: string, body: UnitCommissionsMarkup): Observable<void>;

  // ── Comercio: markup (lee live del micro) ──────────────────────────────────
  abstract getMerchantCommissions(idMerchant: string): Observable<CommissionsReadDto | null>;
  abstract updateMerchantCommissions(idMerchant: string, body: MerchantCommissionsMarkup): Observable<void>;
}
